module.exports = __webpack_public_path__ + "static/media/icon_05.e7d9434d.png";